import React from 'react';
import { MdConfirmationNumber } from 'react-icons/md';

import HostActions from './HostActions';
import GuestActions from './GuestActions';
import { getEventPricing } from '../../helpers';

const EventActionBar = ({
  event,
  toggleScanQRModal,
  toggleManageEvent,
  user,
  setIsTicketModalOpen,
  toggleCheckout,
  toggleShareModal,
  toggleViewContactsModal
}) => {
  const priceRangeNoDiscount = getEventPricing(event);

  // We want to show the get tickets button only in the following cases:
  //    - User is NOT logged in
  //    - User IS logged in AND is not an organizer nor a scanner AND event can be joined OR the user was invited to it.
  const canGetTickets =
    !user ||
    (user &&
      !event.isOrganizer &&
      !event.isScanner &&
      !event.isPhotographer &&
      (event.userStatus === 'joinable' ||
        event.userStatus === 'invited' ||
        event.userStatus === 'attending'));

  const canShare = !(event.private && !event.isOrganizer);

  return (
    <div className="w-full fixed left-0 bottom-0 bg-white pb-8 z-50 md:pb-4 shadow-primary-50 shadow-top md:shadow-none">
      {canGetTickets && (
        <button
          type="submit"
          disabled={event.activeStatus === 'past'}
          className="h-[70px] bg-primary-800 py-4 w-full text-white text-base flex items-center justify-center disabled:opacity-70"
          onClick={
            event.userStatus === 'attending'
              ? () => setIsTicketModalOpen(true)
              : toggleCheckout
          }
          data-testid={
            event.userStatus === 'attending'
              ? 'button-view-ticket'
              : 'button-get-tickets'
          }
        >
          {event.userStatus === 'attending' ? (
            <>
              View Tickets
              <MdConfirmationNumber className="ml-2" size={20} />
            </>
          ) : (
            <>
              Get Tickets - {priceRangeNoDiscount}
              <MdConfirmationNumber className="ml-2" size={20} />
            </>
          )}
        </button>
      )}

      <div className="md:w-[630px] md:mx-auto flex items-center justify-between pt-4 px-4">
        {event.isOrganizer || event.isScanner || event.isPhotographer ? (
          <HostActions
            event={event}
            onClickViewQrScanner={toggleScanQRModal}
            onClickViewShareOptions={toggleShareModal}
            onClickManageEvent={toggleManageEvent}
            canShare={canShare}
          />
        ) : (
          <GuestActions
            onClickViewShareOptions={toggleShareModal}
            onClickViewContactsModal={toggleViewContactsModal}
            canShare={canShare}
            isLoggedIn={Boolean(user)}
          />
        )}
      </div>
    </div>
  );
};

export default EventActionBar;
